export default __webpack_public_path__ + "static/media/reformcloud_horizontal.373de7f3.png";